import Form from './Form';

export class ContactForm extends Form {
    constructor (target) {
        console.log('Module: ContactForm has been loaded', target);

        super(target);
    }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./app/src/js/modules/ContactForm.js